import React from 'react';
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar';
const sizesMap = {
    circle: 'full',
    squared: 'none',
    rounded: 'md',
};
export const roundedMapper = (size) => sizesMap[size];
export const ImageBlock = ({ url, size = 'md', shape = 'circle', }) => {
    if (!url) {
        return null;
    }
    return (React.createElement(Avatar, { size: size, rounded: roundedMapper(shape), src: url, className: "flex" }));
};
//# sourceMappingURL=Block.js.map